import { render, staticRenderFns } from "./MemberMessage.vue?vue&type=template&id=f487092a&scoped=true"
import script from "./MemberMessage.vue?vue&type=script&lang=js"
export * from "./MemberMessage.vue?vue&type=script&lang=js"
import style0 from "./MemberMessage.vue?vue&type=style&index=0&id=f487092a&prod&lang=scss&scoped=true"
import style1 from "./MemberMessage.vue?vue&type=style&index=1&id=f487092a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f487092a",
  null
  
)

export default component.exports